import { atomWithStorage } from 'jotai/utils';

/** Persisted Reflag user context override for the site-centric navigation opt-in. */
export const siteCentricOptInAtom = atomWithStorage<'true' | 'false' | null>(
    'siteCentricOptInAtom',
    null,
    undefined,
    { getOnInit: true }
);
